export default {"src":"/_next/static/media/discord.376f8bdb.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};